// 导出头像路径配置
export const AVATAR_CONFIG = {
    // 使用 require 是为了确保 Webpack 打包时能正确处理图片资源
    // 路径根据你的实际文件名修改
    WIFE: require('@/assets/ak女.jpg'),
    HUSBAND: require('@/assets/盾牌男.jpg'),

    // 如果以后有默认头像，也可以加进来
    DEFAULT: require('@/assets/合照.jpg') // 假设合照.jpg 是默认的
};